// extracted by mini-css-extract-plugin
export var localeSelector = "_av-0";